import axios from 'axios'

import { DataForCreate } from '../../model/stepper-slice'

import { DataForCreateBusiness } from './types'

import {
	FieldActivity,
	FieldActivitySelect,
	Frequency,
	FrequencySelect,
} from '#/features/register-business/lib/constants-step-information'
import { getApiUrl } from '#/shared/lib/constants'

export const createAccount = async (information: DataForCreate, token: string | null) => {
	const indexOfS = Object.values(FrequencySelect).indexOf(information.frequency as unknown as FrequencySelect)

	const companySector = Object.entries(FieldActivitySelect).find(
		([key, value]) => value === information.fieldActivity
	)

	const data: DataForCreateBusiness = {
		company_name: information.companyName,
		company_sector: companySector ? (companySector[0] as FieldActivity) : 'IT',
		ITN: +information.inn,
		corporate_email: information.email,
		corporate_phone: information.phone,
		PSRN: +information.ogrn,
		planned_amount_of_workers: information.numberStuff,
		preferred_name: information.name,
		usage_intensity: Object.keys(FrequencySelect)[indexOfS] as Frequency,
		job_title: information.job_title,
	}

		const res = await axios.post<DataForCreateBusiness>(getApiUrl() + '/auth/business-host/create', data, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})

		return {'data': res.data, 'status': res.status}
}
